module.exports = __webpack_require__.p + "69e098e7f70dae49b97aa297b10c02f0.jpg";